import type { JSX, ReactNode, ComponentPropsWithoutRef } from 'react';
import { styled, css } from 'styled-components';
import { isNil } from '@wistia/type-guards';

const disabledStyle = css`
  color: var(--wui-color-text-disabled);
`;

const StyledFormControlLabelDescription = styled.div<{ $disabled: boolean }>`
  color: var(--wui-color-text-secondary);
  display: block;
  font-size: var(--wui-typography-body-4-size);
  font-weight: var(--wui-typography-body-4-weight);
  line-height: var(--wui-typography-body-4-line-height);

  ${({ $disabled }) => $disabled && disabledStyle}
`;

export type FormControlLabelDescriptionProps = ComponentPropsWithoutRef<'div'> & {
  /**
   * Pass an arbitrary child node
   */
  children: ReactNode;
  /**
   * Whether the description is for a disabled form control
   */
  disabled?: boolean;
};

/**
 * Use in conjunction with a FormControlLabel component to provide additional context or information
 */
export const FormControlLabelDescription = ({
  children,
  disabled = false,
  ...props
}: FormControlLabelDescriptionProps): JSX.Element | null => {
  if (isNil(children)) {
    return null;
  }

  return (
    <StyledFormControlLabelDescription
      {...props}
      $disabled={disabled}
    >
      {children}
    </StyledFormControlLabelDescription>
  );
};

FormControlLabelDescription.displayName = 'FormControlLabelDescription';
